export default "__VITE_ASSET__DIw9E6pL__"